module.exports = __webpack_public_path__ + "static/dl2-stay-human_background-e098c8b44e1150b406e92514cacd91da.jpg";